export default "__VITE_ASSET__DNgH093T__"